<template>
    <div :style="{'display':'flex'}">
        <div class="demo-image__placeholder" :style="{'width':'250px'}">
            <div class="block">
                <el-image :src="src"></el-image>
            </div>
        </div>
        <div :style="{'flex':'1','margin-left':'15px'}">
            <el-row :gutter="20" :style="{'height':'35px'}">
                <el-col :span="6" :style="{'font-size':'35px'}"><div class="grid-content bg-purple">{{this.$store.state.a.searchWord}}</div></el-col>
                <el-col :span="18" :style="{'line-height':'35px'}"><div class="grid-content bg-purple">{{this.$store.state.a.words.fanyi}}</div></el-col>
            </el-row>
            <el-row :gutter="20" :style="{'line-height':'35px'}">
                <el-col :span="6"><div class="grid-content bg-purple">{{this.$store.state.a.words.yinjie}}</div></el-col>
                <el-col :span="6"><div class="grid-content bg-purple">{{this.$store.state.a.words.cixing}}</div></el-col>
                <el-col :span="12"><div class="grid-content bg-purple">{{this.$store.state.a.words.yinbiao}}</div></el-col>
            </el-row>
            <el-row>
                <el-col :span="24"><div class="grid-content bg-purple-dark">{{this.$store.state.a.words.ciyuan}}</div></el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
    export default {
        name: "WordDetils",
        computed:{
            src(){
                return "http://heiline.ltd/ademo/pic/"+this.$store.state.a.searchWord+".jpg";
            },

        },
    }
</script>

<style scoped>
    .el-row {
        margin-bottom: 20px;
    &:last-child {
         margin-bottom: 0;
     }
    }
    .el-col {
        border-radius: 4px;
    }
    .bg-purple-dark {
        background: #99a9bf;
    }
    .bg-purple {
        background: #d3dce6;
    }
    .bg-purple-light {
        background: #e5e9f2;
    }
    .grid-content {
        border-radius: 4px;
        min-height: 36px;
    }
    .row-bg {
        padding: 10px 0;
        background-color: #f9fafc;
    }
</style>